import React from "react";
const TdElement = ({ tdItem }) => {
  switch (tdItem?.type) {
    case "input":
      return (
        <>
          {tdItem.title}
          <div className={`pt-1 ${tdItem.className ?? ""}`}>
            <b>{tdItem.value}</b>
          </div>
          {tdItem.footerText && <div>{tdItem.footerText}</div>}
        </>
      );
    case "checkboxes":
      return (
        <div className="mt-2">
          {tdItem.title && <p>{tdItem.title}</p>}

          {tdItem.options.map((item, j) => (
            <div className="row mb-2 ml-0" key={j}>
              <div className="col-2 checkboxDiv">
                <div className="d-flex align-content-end flex-wrap">
                  <label className="container">
                    <input
                      type="checkbox"
                      checked={tdItem.values?.[item.value] && tdItem.values?.[item.value] !== "0"}
                    />
                    <span className="checkmark" />
                  </label>
                </div>
              </div>
              <div className="col-10 pl-1 pr-0">
                <span className="eb_fs_20">{item.label}</span>
              </div>
            </div>
          ))}
          {tdItem.footerText && <p className="pt-3 mb-1">{tdItem.footerText}</p>}
        </div>
      );
    case "checkboxesH":
      return (
        <div className="mt-2 w-100">
          {tdItem.title && <p>{tdItem.title}</p>}
          <div className="d-flex row ml-1">
            {tdItem.options.map((item, j) => (
              <div
                className={`${item.className ||
                  `col-${Math.max(Math.ceil(12 / tdItem.options.length), 2)}` ||
                  "mr-4"}`}
                key={j}
              >
                <div>
                  <div className="row d-flex containerRadio eb_fs_20">
                    <div className="radioContainerText">{item.label}</div>
                    <div>
                      {/* <label className="container">
                        <input
                          type="checkbox"
                          checked={
                            tdItem.values?.[item.value] && tdItem.values?.[item.value] !== "0"
                          }
                        />
                         <span className="checkmark" />
                        </label> */}
                      <label className="checkContainer">
                        <input
                          type="checkbox"
                          checked={
                            tdItem.values?.[item.value] && tdItem.values?.[item.value] !== "0"
                          }
                        />
                        <span className="checkmark" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {tdItem.footerText && <div>{tdItem.footerText}</div>}
        </div>
      );
    case "radio":
      return (
        <div className="mt-2">
          {tdItem.title && <p>{tdItem.title}</p>}
          <div className="row  px-3">
            {tdItem.options.map((item, j) => (
              <div
                className={`mb-2 ${item.className ||
                  tdItem.radioClassName ||
                  `col-${Math.max(Math.ceil(12 / tdItem.options.length), 2)}`}`}
                key={j}
              >
                <div>
                  <div className="row d-flex containerRadio eb_fs_20">
                    <div className="align-self-center radioContainerText">{item.label}</div>
                    <div>
                      <input
                        type="radio"
                        className="d-none"
                        checked={tdItem.value && item.value === tdItem.value}
                      />
                      <span className="checkmarkRadio"></span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {tdItem.footerText && <div>{tdItem.footerText}</div>}
        </div>
      );
    case "text":
      return (
        <>
          <div className="pt-1">{tdItem.value}</div>
        </>
      );
    case "mapInfo":
      return (
        <>
          <div>{tdItem.title}</div>
          <div className="row" aa={1}>
            {tdItem.data.map((el, j) => (
              <div className={el.className} key={j}>
                <div className="d-flex justify-content-start">
                  <div className="mx-2">
                    <b>{el.title}</b>
                  </div>
                  <div className="mx-2">{el.value}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      );

    default:
      return <></>;
  }
};

export const TableElement = (tableData, groupOptions, title, tableClass) => (
  <div className="avoidPageBreakInside">
    {title && (
      <div className="pl-5 eb_fs_20">
        <b>{title}</b>
      </div>
    )}
    <table className={`tablePrint ${tableClass ?? ""}`}>
      {groupOptions && (
        <colgroup>
          {groupOptions.map(grItem => (
            <col width={grItem.width} />
          ))}
        </colgroup>
      )}
      <tbody>
        {tableData?.map(trItem => (
          <>
            {trItem ? (
              <tr>
                {trItem?.map(tdItem => (
                  <td
                    className={`tdPrint ${tdItem.className || ""}`}
                    width={tdItem.width || "auto"}
                    colSpan={tdItem.colSpan || 1}
                    rowSpan={tdItem.rowSpan || 1}
                  >
                    <TdElement tdItem={tdItem} />
                  </td>
                ))}
              </tr>
            ) : null}
          </>
        ))}
      </tbody>
    </table>
  </div>
);
